var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11665 9.31348H22.9579C23.2343 9.31348 23.4993 9.4267 23.6947 9.62823C23.8902 9.82976 24 10.1031 24 10.3881C24 10.6731 23.8902 10.9464 23.6947 11.148C23.4993 11.3495 23.2343 11.4627 22.9579 11.4627H2.11665C1.84028 11.4627 1.57522 11.3495 1.3798 11.148C1.18437 10.9464 1.07458 10.6731 1.07458 10.3881C1.07458 10.1031 1.18437 9.82976 1.3798 9.62823C1.57522 9.4267 1.84028 9.31348 2.11665 9.31348Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5167 10.3881L11.1572 19.0007C11.3528 19.1958 11.4627 19.4603 11.4627 19.7361C11.4627 20.012 11.3528 20.2765 11.1572 20.4715C10.9616 20.6665 10.6962 20.7761 10.4196 20.7761C10.143 20.7761 9.87764 20.6665 9.68202 20.4715L0.30606 11.1234C0.209043 11.027 0.132071 10.9123 0.0795525 10.7861C0.0270337 10.66 0 10.5247 0 10.3881C0 10.2514 0.0270337 10.1162 0.0795525 9.98997C0.132071 9.86378 0.209043 9.74916 0.30606 9.65268L9.68202 0.304605C9.87764 0.109569 10.143 0 10.4196 0C10.6962 0 10.9616 0.109569 11.1572 0.304605C11.3528 0.49964 11.4627 0.764165 11.4627 1.03999C11.4627 1.31581 11.3528 1.58033 11.1572 1.77537L2.5167 10.3881Z",
    fill: "#404040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back-arrow-icon.ea7767076c051b3a5ed607510ba4de7a.svg";
export { ForwardRef as ReactComponent };